export const constyjyp = {
    TOKEN_KEY: 'yjypwebtoken',
    USER_INFO: 'yjypUserInfo',
    JTI: 'jti',
    APPINFO:'yjypAppInfo',
    ISOLD:'ISOLD'
}



// WEBPACK FOOTER //
// ./src/core/constyjyp.js